function createPlaceholder(image) {
  const width = Math.max(image.width || 640, 1);
  const height = Math.max(image.height || 400, 1);
  const label = 'Imagen no disponible';
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}"><rect width="100%" height="100%" fill="#111111"/><text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" fill="#a1a1aa" font-family="sans-serif" font-size="16">${label}</text></svg>`;
  image.src = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  image.alt = image.alt || label;
}

export function initImageErrorHandler() {
  document.addEventListener('error', (event) => {
    const image = event.target;

    if (!(image instanceof HTMLImageElement) || image.dataset.errorHandled === 'true') {
      return;
    }

    image.dataset.errorHandled = 'true';
    image.classList.add('img-error');

    if (image.dataset.fallback) {
      image.src = image.dataset.fallback;
      return;
    }

    createPlaceholder(image);
  }, true);
}
